export default function LabelComponent({ children }) {
    return (
        <div className="label-component">
            <label>{children}</label>
        </div>
    );
}
